import { createAction } from "redux-actions";

import { SET_LOYALTY_IS_ENABLED } from "../constants";

const setLoyaltyIsEnabled = createAction(SET_LOYALTY_IS_ENABLED);

export default setLoyaltyIsEnabled;
